import { useEffect, useState } from 'react';
import QRCode from 'qrcode';
import { QrCode, Printer } from '@phosphor-icons/react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { printBihinQrLabel } from './bihinQrLabel';

/**
 * QRラベルの確認ダイアログ。
 * いきなりブラウザの印刷画面が出ると画面が止まってしまうので、
 * まず実際のラベルの見た目を出して、押したときだけ印刷に進む。
 */
export default function BihinQrLabelDialog({ open, onOpenChange, item }) {
  const [dataUrl, setDataUrl] = useState('');

  useEffect(() => {
    if (!open || !item?.id) { setDataUrl(''); return; }
    const url = `${window.location.origin}/bihin/items?open=${item.id}`;
    QRCode.toDataURL(url, { width: 240, margin: 1 }).then(setDataUrl).catch(() => setDataUrl(''));
  }, [open, item]);

  if (!open) return null;
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md" aria-describedby={undefined} data-testid="bihin-qr-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2"><QrCode size={18} />QRラベルの確認</DialogTitle>
        </DialogHeader>
        <p className="text-xs text-zinc-500">
          このラベルを印刷します（70mm × 40mm）。スキャンするとこの備品の詳細が開きます。
        </p>
        <div className="flex items-center gap-4 rounded-lg border border-dashed border-zinc-300 bg-white p-4"
          data-testid="bihin-qr-preview">
          <div className="h-28 w-28 shrink-0 bg-zinc-50">
            {dataUrl
              ? <img src={dataUrl} alt="QR" className="h-full w-full object-contain" />
              : <div className="flex h-full items-center justify-center text-[10px] text-zinc-400">生成中…</div>}
          </div>
          <div className="min-w-0">
            <div className="font-mono text-sm font-bold text-zinc-800" data-no-translate>{item?.no || '—'}</div>
            <div className="mt-1 break-words text-xs font-bold text-zinc-700" data-no-translate>{item?.name || ''}</div>
            {item?.sub && <div className="mt-1 break-words text-[10px] text-zinc-500" data-no-translate>{item.sub}</div>}
          </div>
        </div>
        <div className="flex justify-end gap-2 pt-1">
          <Button variant="outline" onClick={() => onOpenChange(false)} data-testid="bihin-qr-cancel">閉じる</Button>
          <Button disabled={!dataUrl} data-testid="bihin-qr-print"
            onClick={() => { printBihinQrLabel(item); onOpenChange(false); }}>
            <Printer size={14} className="mr-1" />印刷する
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
